import React, { PropsWithChildren } from 'react';
import './sandwichBox.scss';

type OwnProps = {
  top_bun?: JSX.Element;
  bottom_bun?: JSX.Element;
  spread?: string;
};
export type SandwichProps = PropsWithChildren<OwnProps>;
const Sandwich: React.FC<SandwichProps> = (props) => {
  const className = `sandwich_box ${props.spread}`;
  return (
    <div className={className}>
      <div className="sb_top_bun">{props.top_bun}</div>
      <div className="sb_filling">{props.children}</div>
  <div className="sb_bottom_bun">{props.bottom_bun}</div>
    </div>
  );
};

export default Sandwich;
